export default "<syr-root-data></syr-root-data>"